// Offres Side-B : noms, ordre et code couleur partagés par tout le site.
// Gratuit = neutre · Essentiel = orange · Pro = vert · Max = violet
// (les classes Tailwind sont écrites en entier pour être détectées au build)

export const TIER_ORDER = ["free", "essentiel", "pro", "max"];
export const TIER_LABEL = { free: "Gratuit", essentiel: "Essentiel", pro: "Pro", max: "Max" };

export const TIER_STYLE = {
  free: {
    badge: "bg-white/5 text-zinc-300 border-white/15",
    text: "text-zinc-300",
    title: "text-zinc-200",
    border: "border-white/10",
    soft: "bg-white/[0.03] border-white/10",
    panel: "border-white/10 from-white/[0.04]",
    bar: "bg-zinc-500",
    hover: "hover:border-white/20",
    cta: "bg-emerald-500 text-black hover:bg-emerald-300", // bouton principal dans un encart de cette offre
  },
  essentiel: {
    badge: "bg-orange-500/15 text-orange-300 border-orange-500/40",
    text: "text-orange-300",
    title: "text-orange-300",
    border: "border-orange-500/30",
    soft: "bg-orange-500/[0.06] border-orange-500/40",
    panel: "border-orange-500/30 from-orange-500/[0.08]",
    bar: "bg-orange-400",
    hover: "hover:border-orange-500/40",
    cta: "bg-orange-400 text-black hover:bg-orange-300", // bouton principal dans un encart de cette offre
  },
  pro: {
    badge: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
    text: "text-emerald-300",
    title: "text-emerald-300",
    border: "border-emerald-500/30",
    soft: "bg-emerald-500/[0.06] border-emerald-500/40",
    panel: "border-emerald-500/30 from-emerald-500/[0.08]",
    bar: "bg-emerald-400",
    hover: "hover:border-emerald-500/40",
    cta: "bg-emerald-500 text-black hover:bg-emerald-300", // bouton principal dans un encart de cette offre
  },
  max: {
    badge: "bg-violet-500/15 text-violet-300 border-violet-500/40",
    text: "text-violet-300",
    title: "text-violet-300",
    border: "border-violet-500/30",
    soft: "bg-violet-500/[0.06] border-violet-500/40",
    panel: "border-violet-500/30 from-violet-500/[0.08]",
    bar: "bg-violet-400",
    hover: "hover:border-violet-500/40",
    cta: "bg-violet-500 text-white hover:bg-violet-400", // bouton principal dans un encart de cette offre
  },
};

export const tierStyle = (tier) => TIER_STYLE[tier] || TIER_STYLE.free;
export const tierRank = (tier) => Math.max(0, TIER_ORDER.indexOf(tier || "free"));
export const tierCovers = (userTier, required) => tierRank(userTier) >= tierRank(required);

// « 9,99 €/mois » à partir de /config (tiers.<id>.price_eur)
export function tierPrice(cfg, tier, suffix = " €/mois") {
  const entry = cfg?.tiers?.[tier];
  if (!entry || !entry.price_eur) return null;
  return `${entry.price_eur.toString().replace(".", ",")}${suffix}`;
}
